import { getCookie } from "./cookies";

const TOKEN = getCookie(process.env.ACCESS_TOKEN);

const cookieToLocales = { _ptBR: "pt-BR", _esALT: "es", _enUS: "en" };

export const fetcherWithToken = (url) =>
  fetch(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${TOKEN}`,
      "Accept-Language":
        cookieToLocales[getCookie("IntegracaoLoginIdioma")] ?? "pt-BR",
    },
  }).then((res) => res.json());
